import { Controller } from "@hotwired/stimulus";

export default class NumberVariableToggleController extends Controller {
  static targets = ["modeSelect", "numberInputContainer", "variableContainer", "variableSelect"];
  static values = { fieldName: String };

  toggle() {
    const mode = this.modeSelectTarget.querySelector("input[type=hidden]")?.value;
    const isVariable = mode === "variable";

    this.numberInputContainerTarget.classList.toggle("hidden", isVariable);
    this.variableContainerTarget.classList.toggle("hidden", !isVariable);

    const numberInput = this.numberInputContainerTarget.querySelector("input[type=number]");
    const variableInput = this.variableSelectTarget.querySelector("input[type=hidden]");

    if (numberInput) numberInput.name = isVariable ? "" : this.fieldNameValue;
    if (variableInput) variableInput.name = isVariable ? this.fieldNameValue : "";
  }
}
